import { useMutation, useQueryClient } from '@tanstack/react-query';
import { adminToolsService } from '@/services/admin/AdminToolsService';
import type { ResetDemoSeedDataResponse } from '@/services/admin/AdminToolsService';

export const useResetDemoSeedData = () => {
  const queryClient = useQueryClient();

  return useMutation<ResetDemoSeedDataResponse, Error, void>({
    mutationFn: () => adminToolsService.resetDemoSeedData(),
    onSuccess: () => {
      // Invalidate all cached data since seed reset affects everything
      queryClient.invalidateQueries();
    },
  });
};
